import { Link } from 'react-router-dom'

export const NotFoundPage = () => {
    return(
        <main className="grid min-h-full place-items-center bg-gray-950 px-6 py-24 sm:py-32 lg:px-8">
            <div className="text-center">
                <p className="text-base font-bold text-slate-100">404</p>
                    <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-300 sm:text-5xl">Page not found</h1>
                <p className="mt-6 text-base leading-7 text-gray-100">Sorry, we couldn’t find the page you’re looking for.</p>
                <div className="mt-10 flex items-center justify-center gap-x-6">
                    <Link 
                        to="/"
                        className="rounded-md bg-slate-100 px-3.5 py-2.5 text-sm font-semibold text-slate-950 shadow-sm hover:bg-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                        Go back home
                    </Link>
                    <Link to="/contact" className="text-sm font-semibold text-gray-100">
                        Contact support <span aria-hidden="true">&rarr;</span>
                    </Link>
                </div>
            </div>
      </main>
    )
}